<template>
  <div id="app">
      <div class="loadcon" v-if="loading">
        <van-loading type="spinner" />
      </div>
      <router-view />
      <van-tabbar v-if='isshowed' v-model="activeTabName" active-color="#323233" inactive-color="#000" @change="switchTab">
          <van-tabbar-item name="index" >
            <span>首页</span>
            <template #icon="props">
              <van-icon :name="CurRouteName=='index' ? 'wap-home' : 'wap-home-o'" />
            </template>
          </van-tabbar-item>
          <van-tabbar-item name="fahuo">
            <span>发货</span>
            <template #icon="props">
                <van-icon :name="CurRouteName=='fahuo' ? 'shop' : 'shop-o'" :badge="fahuonums" v-if='fahuonums>0'/><van-icon :name="CurRouteName=='fahuo' ? 'shop' : 'shop-o'" v-else/>
            </template>
         </van-tabbar-item>
          <van-tabbar-item name="orderlist">
              <span>订单</span>
              <template #icon="props">
                  <van-icon :name="CurRouteName=='orderlist' ? 'todo-list' : 'todo-list-o'" />
              </template>
          </van-tabbar-item>
          <van-tabbar-item name="my">
             <span>我的</span>
              <template #icon="props">
                  <van-icon :name="CurRouteName=='my' ? 'manager' : 'manager-o'" />
              </template>
          </van-tabbar-item>
      </van-tabbar>
  </div>
</template>
<script>
import { Tabbar, TabbarItem,Icon,Loading} from 'vant';
export default {
   name: 'index',
   data() {
      return {
        activeTabName:'index'
      }
   },
   watch:{
       $route(){
          if(this.$route.name!=this.activeTabName) this.activeTabName=this.$route.name
      }
   },
   computed:{
       isshowed:function(){
           const TabbarList=['index','home','orderlist','my','fahuo']
           if(TabbarList.includes(this.$route.name)){
               return true
           }else{
               return false
           }
       },
       loading(){
          return this.$store.state.app.loading
       },
       fahuonums(){
          return this.$store.state.app.fahuonums
       },
       CurRouteName(){
          return this.$route.name
       }
   },
   methods:{
      switchTab(){
         this.$go('/'+this.activeTabName)
      }
   },
   components: {
        [Icon.name]: Icon,
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem,
        [Loading.name]:Loading
   }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.loadcon{display: flex;justify-content: center;align-items: center;position: absolute;left:0;top:0;width:100%;height:100vh;z-index:9999;}
</style>
